<app-breadcrumb></app-breadcrumb>

<div class="container-fluid">

  <div class="title-wrapper">
    <div class="left">
      <h1>
        {{"My Bulgari"|translate}}
      </h1>
      <a routerLink="/set-store">
        {{"Change Store"|translate}}
      </a>
    </div>

    <div class="right">
      <div class="store">
        <div class="image-wrapper">
          <img src="assets/images/my-bulgari-banner.png" alt="">
        </div>
        <div class="name">
          {{authService.store?.nameStore}}
        </div>

      </div>

    </div>
  </div>

  <hr>

  <h2>
    {{"Exclusive Store Services"|translate}}
  </h2>

  <div class="features-wrapper">

    @if(authService.storeFeatures().length > 0){
    <button class="btn btn-light feature" *ngFor="let feature of authService.storeFeatures()"
      (click)="handleFeatureClick(feature.feature)">
      <img [src]="feature.image" alt="">
      <div class="bg"></div>
      <div class="detail">
        <span class="name">{{feature.name|translate}}</span>
        <span class="description">{{feature.description|translate}}</span>
      </div>
    </button>
    }@else {
    <app-placeholder [message]="'No Store Services Available'|translate"></app-placeholder>
    }

  </div>

</div>

<app-ribbon-modal #ribbonModal></app-ribbon-modal>
